type DataType = {
  [key: string]: string | number | boolean | Array<string | number | boolean> | undefined;
};

/**
 * ゲスト用HTTPクライアント
 * 認証不要のAPIエンドポイントに使用する。
 * http.ts と同じインターフェースだが、Authorization ヘッダーを付与しない。
 */
export const httpGuest = async <T>(
  path: string,
  options?: {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    headers?: { [key: string]: string | undefined };
    body?: BodyInit;
    query?: DataType;
  },
): Promise<T> => {
  const {
    method = 'GET',
    body,
    query,
    headers = {
      'Content-Type': 'application/json',
    },
  } = options ?? {};

  const url = new URL(process.env.NEXT_PUBLIC_API_BASE_URL as string);

  url.pathname = path;

  if (query) {
    for (const k of Object.keys(query)) {
      const queryValue = query[k];
      if (Array.isArray(queryValue)) {
        for (const v of queryValue) {
          url.searchParams.append(`${k}[]`, String(v));
        }
      } else if (queryValue != null) {
        url.searchParams.append(k, String(queryValue));
      }
    }
  }

  const filteredHeaders: Record<string, string> = {};
  if (headers) {
    for (const [key, value] of Object.entries(headers)) {
      if (value !== undefined) {
        filteredHeaders[key] = value;
      }
    }
  }

  const res = await fetch(url.toString(), {
    method: method,
    body: body,
    headers: filteredHeaders,
    next: { revalidate: 0 },
  });

  const responseJson = await res.json();

  if (responseJson.code !== 0) {
    return Promise.reject(responseJson);
  }

  return responseJson;
};
